import React from 'react';
import { Tooltip } from '@prisjakt/ui/tooltip';
import { Direction } from '@prisjakt/ui';
import { BadgeSize } from '@prisjakt/ui/badge';
import { IconPrisjakt } from '@prisjakt/ui/icon/prisjakt';
import { useAppContext } from 'src/components/app-context';
import { usePriceRowContext } from '../../../price-row-context';
import { StyledOurChoiceBadge, StyledOurChoiceBadgeWrapper } from './styles';

export const OurChoiceBadge = () => {
  const { t } = useAppContext();
  const { viewSize } = usePriceRowContext();

  return (
    <StyledOurChoiceBadgeWrapper $viewSize={viewSize}>
      <Tooltip
        title={t('product', 'prices.our-choice-explanation')}
        placement={Direction.Up}
      >
        <StyledOurChoiceBadge
          size={BadgeSize.SMALL}
          color="BLUE_INVERTED"
          text={t('product', 'prices.our-choice')}
          icon={IconPrisjakt}
        />
      </Tooltip>
    </StyledOurChoiceBadgeWrapper>
  );
};
